import NavBar from "@/components/organisms/NavBar";
import Hero from "@/components/organisms/Hero";
import Section2 from "@/components/organisms/Section2";
import TestimonialsSection from "@/components/organisms/TestimonialsSection";
import Banner from "@/components/organisms/Banner";
import Footer from "@/components/organisms/Footer";

export default function HomePage() {
  return (
    <main className="">
      <NavBar />
      <Hero />
      <div id="section-1" className="flex flex-col items-center justify-center">
        <Section2 />
      </div>
      <TestimonialsSection />
      <Banner />
      <Footer />
    </main>
  );
}
